import React from 'react'

const AttestationErrorComp = () => {
    return (
        <div className="error-page">
          <div className="error-container">
            <img src="img/icon/error.svg" alt="Error icon" />
            <div>
              <h3>Invalid Attestation</h3>
              <div>You are not permitted to view this attestation</div>
            </div>
          </div>
        </div>
      );
}

export default AttestationErrorComp;